import { EducationLevelService } from '../../services/educationlevel.service';
import { Component, OnInit, ViewChild, NgZone, OnDestroy, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MdDialog } from '@angular/material';
import { JobOffersService } from '../../services/job-offers.service';
import { JobsOffer } from '../../models/jobs-offer';
import { NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder } from "@angular/forms";
import { ApplicantFilter } from '../../interfaces/filters';
import { Observable } from "rxjs";
import { Constants } from '../constants';
import { MapsAPILoader } from '@agm/core';
import { } from 'googlemaps';
import { GenderService } from '../../services/gender.service';
import { Gender } from '../../models/gender';
import { VenueCompleterComponent } from '../venue-completer/venue-completer.component';
import { ProfileStore } from '../state/profile.store';
import { ProfileNoLocationStore } from '../state/profile-no-location.store';
import { MessageBoxDialog } from '../message-box/message-box.component';

@Component({
  selector: 'app-search-candidates-map',
  templateUrl: './search-candidates-map.component.html',
  styleUrls: ['./search-candidates-map.component.css']
})

export class SearchCandidatesMapComponent implements OnInit, OnDestroy {
  public jobId: string;
  public job: JobsOffer;
  public loaded: boolean;

  loading: Observable<boolean>;

  public jobs:Observable<any>;
  public candidates: any;
  public errorMessage: string;

  public form: FormGroup;
  public hasReq: boolean = true;
  public countReq: number;
  public countNonReq: number;

  public inviteView: boolean;
  public searchView: boolean;

  public advancedSearch:boolean;

  public location: any;
  public zoom: number = 5;
  public addresses : any;
  public placeSelected: boolean = false;
  public radiusKm: number = 1;
  public radiusMts: number = 1000;

  public venue_name: String = "";
  public address_name: String = "";

  educationLevel: any;

  query_skill: string;
  query_edu: string;
  query_exp: string;
  query_sex: string;
  query_edulvl: string;
  query_language: string;
  query_course: string;
  query_description: string;
  query_radius: string;

  public select_gender: any;

  @ViewChild("address") public searchElementRef: ElementRef;

  public STATUS = Constants;

  constructor(private route: ActivatedRoute,
              private _router: Router,
              private fb: FormBuilder,
              private jobService: JobOffersService,
              public dialog: MdDialog,
              private _ngZone: NgZone,
              private mapsAPILoader: MapsAPILoader,
              private genderService:GenderService,
              public profileStore: ProfileStore,
              public profileNoLocationStore: ProfileNoLocationStore,
              public educationLevelService: EducationLevelService
            ) {
  }

  ngOnInit() {
    this.profileStore.restore();
    //this.profileNoLocationStore.restore();
    this.loading = this.profileStore.loading.share();

    this.location = {
      latitude: 4.729726,
      longitude: -74.064331
    }

    this.educationLevelService.get()
      .subscribe(
        data => {
          this.educationLevel = data;
        },
        error => this.errorMessage = <any>error
      );

    this.genderService.getGender().subscribe((data:Gender) => {
      this.select_gender = data;
    });

    this.advancedSearch = false;
    this.form = this.fb.group({
      query: [''],
      query_skill: [''],
      query_edu: [''],
      query_exp: [''],
      query_sex: [''],
      query_edulvl: [''],
      query_language: [''],
      query_course: [''],
      query_description: [''],
      query_radius: [''],
      query_latitude: [''],
      query_longitude: [''],
      query_countryadmin1: [''],
      query_countryadmin2: [''],
      query_country: [''],
      jobId: [''],
      filters: this.fb.group({
        favorite: [''],
        read: [''],
        unread: [''],
        rejected: [''],
        selected: [''],
        hired: ['']
      })
    });

    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["address"]
      });
      autocomplete.addListener("place_changed", () => {
        this.zoom = 14;
        this.placeSelected = false;

        this._ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
          this.setAddress(place);
        });
      });
    });

    this.route.params.subscribe(params => {
      this.jobId = params['jobId'];

      if (typeof this.jobId != 'undefined') {
        if (this.route.snapshot.url[0].path == 'invite')  {
          this.inviteView = true;
        } else {
          this.searchView = true;
        }

        if (!this.inviteView) {
          this.form.controls['jobId'].setValue(this.jobId);
          this.form.value.jobId = this.jobId;
        }

        this.jobService.getOffersById(this.jobId).subscribe(
          data => {
            this.job = data;
            this.loaded = true;
          },
          error => this.errorMessage = <any>error
        );
      } else {
        this.form.controls['jobId'].setValue('');
      }
      let status = [];
      status.push('1');
      status.push('-1');
      status.push('-2');
      status.push('-6');
      this.jobs = this.jobService.getOffers(undefined, undefined, status, 1, 1000000).map(res => res.jobs);
    });
  }

  ngOnDestroy() {
  }

  getVenue($event){
    if ($event.name != null){
      this.setAddressWithVenue($event);
    }
  }

  updateFilters(filters: ApplicantFilter, valid: boolean) {
    if (this.validSearch()){
      if (valid && filters.query_country) {
        this.profileStore.changeFilters(filters,1,10000);
        this.profileNoLocationStore.changeFilters(filters,1,10);
      }
    }else{
      this.dialog.open(MessageBoxDialog, {data: {message: 'es obligatorio elegir como mínimo un criterio de búsqueda y coloque la sede o la dirección.', information: true, showIcon: true}});
    }
  }

  beforeTabChange($event: NgbTabChangeEvent) {
    this.hasReq = $event.nextId === 'reqyes';
  }

  onAdvanceSearch() {
    if (this.advancedSearch) {
      this.advancedSearch = false;
    } else {
      this.advancedSearch = true;
    }
  }

  putOffersStatus(job, status) {
    this.jobService.putOffersStatus(job.id, status)
      .subscribe(
        data => {},
        error => this.errorMessage = <any>error
      );
  }

  viewJob(jobId) {
    this._router.navigate(['/viewoffer', jobId]);
  }

  viewJobKanban(jobId) {
    this._router.navigate(['/viewjob', jobId]);
  }

  viewIvite(id) {
    this._router.navigate(['/viewinvite/'+id]);
  }

  setAddress(place:Object) {
    this.venue_name = "";
    this.location.isVenue = false;
    place['address_components'].forEach(element => {
      element.types.forEach(element2 => {
        if (element2 == 'administrative_area_level_1'){
          this.location.admin1 = element.long_name;
        }
        if (element2 == 'administrative_area_level_2'){
          this.location.admin2 = element.long_name;
        }
        if (element2 == 'country'){
          this.location.country = element.long_name;
        }
      });
    });

    this._ngZone.run(() => {
      try {
        this.addresses = place['formatted_address'];
        let location = place['geometry']['location'];
        this.placeSelected = true;
        this.location.latitude = location.lat();
        this.location.longitude = location.lng();
      } catch (e) {
        console.log("error:", e)
      }
    });
  }

  setAddressWithVenue(event) {
    this.address_name = "";
    this.location.admin1 = event.admin1;
    this.location.admin2 = event.admin2;
    this.location.country = event.country;
    this.location.latitude = +event.lat;
    this.location.longitude = +event.lng;
    this.zoom = 14;
    this.placeSelected = true;
  }

  markerDragEnd(event: any) {
    this.location.latitude = event.coords.lat;
    this.location.longitude = event.coords.lng;
  }

  circleDragEnd(event) {
    this.location.latitude = event.coords.lat;
    this.location.longitude = event.coords.lng;
  }

  circleRadiusChange(event) {
    this.radiusMts = event;
    this.radiusKm = this.radiusMts / 1000;
  }

  clickedMarker(label: string, index: number) {

  }

  validSearch () {
    if (this.placeSelected && ((this.query_skill  && this.query_skill !== '')
      || (this.query_edu  && this.query_edu !== '')
      || (this.query_exp  && this.query_exp !== '')
      || (this.query_sex  && this.query_sex !== '')
      || (this.query_edulvl  && this.query_edulvl !== '')
      || (this.query_language  && this.query_language !== '')
      || (this.query_course  && this.query_course !== '')
      || (this.query_description  && this.query_description !== '')
      || (this.query_radius  && this.query_radius !== ''))
    ) {
      return true;
    } else {
      return false;
    }
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'Realiza búsquedas en lugares específicos, escribiendo la dirección donde vas a buscar candidatos según habilidades, educación, experiencia, genero, idiomas, cursos o sedes de tu empresa.', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/search-candidates-map/search-candidates-map.component.ts